module.exports = __webpack_public_path__ + "img/logo-vertical-full-black.d91e497a.png";